const styles = () => ({
  processingContainer: { display: 'flex' },
  circularProgress: { marginLeft: '10px' }
});

export default styles;
